import { Menu, MenuItem, SxProps } from '@mui/material';

interface CustomContextMenuProps extends React.HTMLAttributes<HTMLDivElement> {
  anchorEl: HTMLElement | null;
  targetElClassName?: string;
  open: boolean;
  options: string[];
  onOptionClick?: (option: string) => void;
  onClose?: () => void;
  sx?: SxProps;
}

const CustomContextMenu = (props: CustomContextMenuProps) => {
  const {
    anchorEl,
    open,
    options,
    onOptionClick,
    onClose,
    targetElClassName,
    sx,
    ...rest
  } = props;

  return (
    <Menu
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onContextMenu={(event) => {
        event.preventDefault();
        event.stopPropagation();

        if (event.target) onClose?.();

        setTimeout(() => {
          const targetEl = document.querySelector(
            `.${targetElClassName}:hover`
          ) as HTMLElement | undefined;
          targetEl?.dispatchEvent(
            new MouseEvent('contextmenu', { bubbles: true })
          );
        }, 100);
      }}
      sx={sx || {}}
      {...rest}
    >
      {options.map((option) => (
        <MenuItem
          key={option}
          onClick={() => {
            onOptionClick?.(option);
            onClose?.();
          }}
        >
          {option}
        </MenuItem>
      ))}
    </Menu>
  );
};

export default CustomContextMenu;
